import React, { FunctionComponent } from 'react';
import { BasicSeoElements } from '../BasicSEO';
import { PageSeo } from '../../../types';

type SearchResultsPageSEOProps = {
  pageSeo: PageSeo;
};

export const SearchResultsPageSEO: FunctionComponent<
  SearchResultsPageSEOProps
> = ({ pageSeo }: SearchResultsPageSEOProps) => (
    <BasicSeoElements
      title={pageSeo?.title}
      description={pageSeo?.description}
      imageUrl={pageSeo?.imageUrl}
      robots={pageSeo?.robots}
    />
  );
